<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						
						
						<el-form-item :label="$t('accountList.type')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.type1')" :value="1"></el-option>
								<el-option :label="$t('accountList.type2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('accountList.isFp')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.yes')" :value="1"></el-option>
								<el-option :label="$t('accountList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('accountList.getType')" class="mb-0">
							<el-select v-model="from.get_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.noGet')" :value="0"></el-option>
								<el-option :label="$t('accountList.yesGet')" :value="1"></el-option>
								<el-option :label="$t('accountList.expireGet')" :value="2"></el-option>
								
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item :label="$t('new1.sup')" class="mb-0">
							<el-select v-model="from.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('accountList.addAccount')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column width="100" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
				</el-table-column>
				
				
				<el-table-column width="100" align="center" prop="sup_name" :label="$t('new1.sup')">
				</el-table-column>
				
				<el-table-column align="center" width="130" prop="ac_id" :label="$t('accountList.ac_id')">
				</el-table-column>
				<el-table-column align="center" width="200" prop="username" :label="$t('adminList.loginName')">
				</el-table-column>
				
				<el-table-column align="center" width="120" prop="password" :label="$t('adminList.loginPassword')">
					<template slot-scope="scope">
						<span>{{scope.row.showPass==1?scope.row.password:scope.row.password2}}</span> <i class="el-icon-view ml-1" @click="changePassShow(scope.row)"></i>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="type" :label="$t('accountList.type')">
					<template slot-scope="scope">
						
						<span class="text-info" v-if="scope.row.type==1">{{$t('accountList.type1')}}</span>
						<span class="" v-if="scope.row.type==2">{{$t('accountList.type2')}}</span>
					</template>
				</el-table-column>	
						
				
				
				<el-table-column align="center" prop="status" width="90" :label="$t('accountList.isFp')">
					<template slot-scope="scope">
						<span v-if="scope.row.type==1">-</span>
						<el-button v-if="scope.row.type==2"
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('accountList.yes') : $t('accountList.no')}}
						</el-button>
					</template>
				</el-table-column>			
				<el-table-column align="center" prop="account_status" width="90" :label="$t('accountList.account_status')">
					<template slot-scope="scope">
						<el-button 
							:type="scope.row.account_status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'account_status')"
							plain>{{scope.row.account_status==1 ? $t('accountList.zc') : $t('accountList.yc')}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="get_status" :label="$t('accountList.getType')">
					<template slot-scope="scope">
						<span  v-if="scope.row.get_status==0">{{$t('accountList.noGet')}}</span>
						<span class="text-success" v-if="scope.row.get_status==1">{{$t('accountList.yesGet')}}</span>
						<span class="text-danger" v-if="scope.row.get_status==2">{{$t('accountList.expireGet')}}</span>
					</template>
				</el-table-column>
				
				
			
				
				
				
				
				
				<el-table-column width="100" align="center" prop="odds" :label="$t('userList.odds')">
				
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="user_name" :label="$t('accountList.getUser')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
			
				
				<el-table-column align="center" prop="money" :label="$t('accountList.money')">
					<template slot-scope="scope">
						{{scope.row.money_type==1?$t('accountList.all'):scope.row.money}}
					</template>
				</el-table-column>
				
				<el-table-column width="100" align="center" prop="use_money" :label="$t('accountList.useMoney')">
					<template slot-scope="scope">
						<span class="">{{scope.row.use_money}}</span>
					</template>
				</el-table-column>
				
				<el-table-column width="100" align="center" prop="need_money" :label="$t('accountList.needMoney')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.need_money}}</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="200" prop="parent_username" :label="$t('accountList.parent')">
				
				</el-table-column>
				
				
				<el-table-column align="center" width="100" prop="remark" :label="$t('userList.remark')">
				</el-table-column>
				
				
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="get_time" :label="$t('accountList.getTime')">
				</el-table-column>
				
				
				<el-table-column align="center"  prop="pro_name" :label="$t('accountList.focus')">
				</el-table-column>
				
				
				<el-table-column align="center"  prop="pro_name" :label="$t('model.log')">
					<template slot-scope="scope">
						<el-link @click="checkLog(scope.row.id)" type="info">{{$t('accountList.check')}}</el-link>
					</template>
				</el-table-column>
				
		
				<el-table-column :width="layout.user.type==1?140:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button :disabled="scope.row.status==0 || scope.row.get_status!=0 || scope.row.type==1" @click="getToUser(scope.row.id)"  size="mini" plain type="success">{{$t('accountList.fp')}}</el-button>
							<el-button v-if="layout.user.type==1" size="mini" plain type="primary" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('adminList.operation')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('accountList.editAccount') : $t('accountList.addAccount')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="getMainAccount" :disabled="editIndex > -1" v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item :label="$t('new1.sup')" prop="sup_id">
					<el-select  :disabled="editIndex > -1" v-model="form.sup_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
			
				<!-- <el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item :label="$t('adminList.loginName')" prop="username">
					<el-input :disabled="editIndex > -1" v-model="form.username"  :placeholder="$t('adminList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginPassword')" prop="password">
					<el-input v-model="form.password" show-password :placeholder="$t('adminList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item   :label="$t('accountList.type')">
					<el-radio-group  :disabled="editIndex > -1" v-model="form.type" size="small">
						<el-radio :label="1" border>{{$t('accountList.type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('accountList.type2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				<el-form-item v-if="form.type==2 && editIndex<=0" :label="$t('accountList.type1')" prop="parent">
					<el-select @change="getMainAccount" :disabled="editIndex > -1" v-model="form.parent" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.account" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item :label="$t('accountList.ac_id')" prop="ac_id">
					<el-input v-model="form.ac_id" :placeholder="$t('accountList.ac_id')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('accountList.keyId')" prop="keyId">
					<el-input v-model="form.access_key_id" :placeholder="$t('accountList.p_keyId')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('accountList.secret')" prop="secret">
					<el-input v-model="form.secret_access_key" :placeholder="$t('accountList.p_secret')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item :label="$t('accountList.focus')" prop="focus">
					<el-select  v-model="form.focus" size="small" filterable :placeholder="$t('system.select')">
					<el-option  :label="$t('status.all')" :value="0">
					</el-option>
						<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('accountList.money')">
					<el-radio-group @input="changeMoneyType" v-model="form.money_type" size="small">
						<el-radio :label="1" border>{{$t('accountList.all')}}</el-radio>
						<el-radio :label="2" border>{{$t('accountList.other')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				
				<el-form-item v-if="form.money_type==2" :label="$t('accountList.money')" prop="money">
					<el-input v-model="form.money" type="number" :placeholder="$t('userList.quota')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
			
				
				
				<el-form-item :label="$t('userList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('userList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item :label="$t('accountList.isFp')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('accountList.yes')}}</el-radio>
						<el-radio :label="0" border>{{$t('accountList.no')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				},
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/accountList", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delAccount", //删除單条地址
				addUrl: "data/addAccount", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					name: [{
						required: true,
						message: this.$t('userList.nameRequired'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('adminList.usernameRequired'),
						trigger: 'blur',
					}],
					password: [{
						required: true,
						message: this.$t('accountList.inpPass'),
						trigger: 'blur'
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					parent: [{
						required: true,
						message: this.$t('accountList.selMainAc'),
						trigger: 'blur',
					}],
					ac_id: [{
						required: true,
						message: this.$t('accountList.inp_ac_id'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
					sup_id:[{
						required: true,
						message: this.$t('new1.selSup'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('account');
		},
		methods: {
			
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						cloud_id: '',
						focus:0,
						username: '',
						password: '',
						status: 1,
						odds: this.odds,
						money:0,
						type:1,
						parent:'',
						money_type:1,
						ac_id:'',
						sup_id:'',
						access_key_id:'',
						secret_access_key:'',
						remark:''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						sup_id: e.sup_id,
						focus:e.focus,
						username: e.username,
						password: e.password,
						status: e.status,
						odds: e.odds,
						type: e.type,
						ac_id: e.ac_id,
						parent: e.parent,
						money:e.money,
						access_key_id:e.access_key_id,
						secret_access_key:e.secret_access_key,
						money_type:e.money_type,
						remark:e.remark
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					if(type=='account'){
						this.agentData.cloud = list.cloud
						this.agentData.product = list.product
						this.agentData.sup = list.sup
						this.odds = list.user_odds
					}else{
						console.log(list)
						console.log(id)
						this.agentData.account = list.account
					}
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
